// Libraries
import { useState } from 'react';
// Redux
import { RootState } from '@redux/rootReducer';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
// Api
import { getProcessPayroll } from '@redux/electronic-payroll/electronicPayroll.slice';
// Models
import { CurrentInformation } from '../constants/InformationImportant';
import { OptionSelected, Options } from '../components/models/ModalInformationImportant';
import { IPeriods } from '@models/Periods';

export const useModalInformationImportant = (
    currentDate?: IPeriods
): {
    showModalImportant: boolean;
    currentInformation: string;
    optionSelected: OptionSelected | null;
    handleShowModalImportant: () => void;
    handleSelectTypeInformation: (currentInformation: CurrentInformation) => void;
    handleSelectOption: (currentOption: Options | null) => void;
    handleMainAction: (currentInformation: string) => Promise<void>;
    handleRedirectionModalInformation: () => void;
    handleErrorModalInformation: () => void;
} => {
    const {
        electronicPayroll: { payroll, token },
    } = useAppSelector((state: RootState) => state);
    const dispatch = useAppDispatch();
    const [showModalImportant, setShowModalImportant] = useState<boolean>(false);
    const [currentInformation, setCurrentInformation] = useState<string>(CurrentInformation.ENABLE_SERVICE);
    const [optionSelected, setOptionSelected] = useState<OptionSelected | null>(null);

    /**
     * Action to open modal information important
     */
    const handleShowModalImportant = (): void => {
        setShowModalImportant(!showModalImportant);
    };

    /**
     * Action to select type information
     * @param {CurrentInformation} currentInformation - Select current type information to show
     */
    const handleSelectTypeInformation = (currentInformation: CurrentInformation): void => {
        setCurrentInformation(currentInformation);
    };

    /**
     * Action to select option inside modal
     * @param {Options | null} currentOption - Option selected from modal information
     */
    const handleSelectOption = (currentOption: Options | null): void => {
        setOptionSelected(currentOption);
    };

    /**
     * Return main action from type modal
     * @param {string} currentInformation - State to get current type modal
     */
    const handleMainAction = async (currentInformation: string): Promise<void> => {
        if (currentInformation === CurrentInformation.CONFIRM_TRANSMISSION) {
            payroll && currentDate && dispatch(getProcessPayroll(payroll?.id, currentDate.period.id));
            handleSelectOption(null);
            handleShowModalImportant();
        } else if (
            currentInformation === CurrentInformation.CHECK_DETAIL ||
            currentInformation === CurrentInformation.CHECK_HISTORIC
        ) {
            window.open(`${process.env.REACT_APP_ELECTRONIC_PAYROLL_DETAIL}${token}`, '_blank', 'noreferrer');
            handleShowModalImportant();
        }
    };

    const handleRedirectionModalInformation = (): void => {
        setCurrentInformation(CurrentInformation.TRANSMITION_REDIRECT);
    };

    const handleErrorModalInformation = (): void => {
        setCurrentInformation(CurrentInformation.PAYROLL_ERROR);
    };

    return {
        showModalImportant,
        currentInformation,
        optionSelected,
        handleShowModalImportant,
        handleSelectTypeInformation,
        handleSelectOption,
        handleMainAction,
        handleRedirectionModalInformation,
        handleErrorModalInformation,
    };
};
